import { chooseService } from './../utils/index';
import {useEffect, useState} from "react";


const useCheckCayugaCerts = () => {
    const url = `https://${window.CONFIG.ServerAddress}:${window.CONFIG.ServerPort}/SeeTecGatewayService/GatewayServiceRest/Request_Client_URL?host=${window.location.origin}`;        
    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
        chooseService(
            () => setIsValid(true),
            () => (async () => {
                    try {
                        await fetch(url);
                        setIsValid(true);
                    } catch(err) {
                        window.location.href = url;
                    }
                })()
        );
    }, []);

    return isValid;
};

export default useCheckCayugaCerts